import type { MonospacePrimitiveField } from '#layers/data-model/types/schema/primitive-field';

/**
 * Whether a field rejects writes, defaulting to writable.
 *
 * Both the capabilities object and the key within it are optional - Studio-only virtual fields
 * carry no capabilities at all - so this defaults per key rather than substituting a whole
 * default object.
 */
export function isPrimitiveFieldReadOnly(field: Partial<Pick<MonospacePrimitiveField, 'queryCapabilities'>>): boolean {
	return field.queryCapabilities?.isReadOnly ?? false;
}
